(function() {
	"use strict";
	angular.module("cbl.finanza.mf.directives").directive("finSpinnerDrct", [ 'FIN_CONSTANTS', function(CONSTANTS) {
		var link = function (scope, elem, attrs, model) {};
		
		var controller = function($scope, brioSrvc) {
			
			this.brioSrvc = brioSrvc;
			
			var self = this;
			
			this.getSpinnerUrl = function() {
	            var url = null;
	            var currentScope = $scope;
	            do {
	                url = currentScope.srcSpinner;
	                currentScope = currentScope.$parent;
	            } while((url === undefined) && (currentScope !== null));
	            return url;
			};

		};
		
		controller.$inject = ['$scope', 'FinBrioSrvc'];
		return {
			restrict : "E",
			scope : { },
			templateUrl : CONSTANTS.BASE_ROOT + "widgets/finSpinner/finSpinner.html",
			controller : controller,
			controllerAs : 'spinner',
			link : link
		};
	}]);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finSpinner/finSpinnerDrct.js
 ** module id = 5
 ** module chunks = 0 1 2
 **/